import * as React from 'react';
import { IconButton, Tooltip, Typography, FormLabel } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';

type SendingFileUploadProps = {
  saveFace: any; // (fileName:Blob) => Promise<void>, // callback taking a string and then dispatching a store actions
};

export const SendingFileUpload = ({ saveFace }: SendingFileUploadProps) => {
  const [selectedFile, setSelectedFile] = React.useState<any>(null);

  const handleCapture = ({ target }: any) => {
    setSelectedFile(target.files[0]);
  };

  return (
    <>
      <FormLabel>Dokument</FormLabel>
      <br />
      <input accept='image/jpeg' style={{ display: 'none' }} id='faceImage' type='file' onChange={handleCapture} />
      <Tooltip title='Välj fil(er)'>
        <label htmlFor='faceImage'>
          <IconButton sx={{ color: 'primary.light' }} color='primary' aria-label='upload picture' component='span' size='large'>
            <AttachFileIcon fontSize='large' />
          </IconButton>
          <Typography component='span' variant='subtitle2'>
            {selectedFile ? selectedFile?.name : 'Välj fil'}. . .
          </Typography>
        </label>
      </Tooltip>
    </>
  );
};
